/**
 * @generated SignedSource<<5e32c3b74232c11a19e5ec54363aae23>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRelatedItems_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_viewer" | "SbSharedThinBrowseItemTrackingProvider_viewer">;
  readonly " $fragmentType": "SbSharedRelatedItems_viewer";
};
export type SbSharedRelatedItems_viewer$key = {
  readonly " $data"?: SbSharedRelatedItems_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRelatedItems_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRelatedItems_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedThinBrowseItemTrackingProvider_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f522df92114cf8392826b9785a8aba68";

export default node;
